/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `Velikost souboru '${i.fileName}' přesahuje limit ${i.fileSizeLimitMo} MB`
};

const da_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `Filen '${i.fileName}' overstiger grænsen på ${i.fileSizeLimitMo} MB`
};

const de_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `Die Datei '${i.fileName}' überschreitet das Limit von ${i.fileSizeLimitMo} MB`
};

const en_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `The file '${i.fileName}' exceeds the limit of ${i.fileSizeLimitMo} MB`
};

const es_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `El archivo '${i.fileName}' supera el límite de ${i.fileSizeLimitMo} MB`
};

const fr_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `La taille du fichier '${i.fileName}' dépasse la limite de ${i.fileSizeLimitMo} Mo`
};

const hu_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `A '${i.fileName}' fájl mérete meghaladja a ${i.fileSizeLimitMo} MB korlátot`
};

const it_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `La dimensione del file '${i.fileName}' supera il limite di ${i.fileSizeLimitMo} MB`
};

const nl_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `Het bestand '${i.fileName}' is groter dan ${i.fileSizeLimitMo} MB`
};

const pl_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `Plik '${i.fileName}' przekracza limit ${i.fileSizeLimitMo} MB`
};

const pt_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `O tamanho do arquivo '${i.fileName}' excede o limite de ${i.fileSizeLimitMo} MB`
};

const sv_contact_alert_file_size = /** @type {(inputs: { fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `Filen '${i.fileName}' överskrider gränsen ${i.fileSizeLimitMo} MB`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ fileName: NonNullable<unknown>, fileSizeLimitMo: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_alert_file_size = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_alert_file_size(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_alert_file_size", locale)
	if (locale === "cs") return cs_contact_alert_file_size(inputs)
	if (locale === "da") return da_contact_alert_file_size(inputs)
	if (locale === "de") return de_contact_alert_file_size(inputs)
	if (locale === "en") return en_contact_alert_file_size(inputs)
	if (locale === "es") return es_contact_alert_file_size(inputs)
	if (locale === "fr") return fr_contact_alert_file_size(inputs)
	if (locale === "hu") return hu_contact_alert_file_size(inputs)
	if (locale === "it") return it_contact_alert_file_size(inputs)
	if (locale === "nl") return nl_contact_alert_file_size(inputs)
	if (locale === "pl") return pl_contact_alert_file_size(inputs)
	if (locale === "pt") return pt_contact_alert_file_size(inputs)
	return sv_contact_alert_file_size(inputs)
};
export { contact_alert_file_size as "contact.alert.file_size" }